import {
  CarOwner,
  CarProductDetailsFormValues,
} from "../ProductDetails/FormElements/interfaces";

import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { CarPriceRequestInfo } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Car";
import { RENTAL_TYPE_VARIABLE } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseCarProduct";
import { UserIdentificationData } from "Store/userIdentification";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";
import { isSTBEmployee } from "Utils/isSTBEmployee";
import { CarProductIntroFormValues } from "../ProductIntro/FormElements/interfaces";
import { CarPriceFormValues } from "../ProductPrice/interfaces";
import { getCarPriceIssueDate } from "./getCarPriceIssueDate";
import { usedByYoungerDriver } from "./usedByYoungerDriver";

export const mapFormToPriceRequest = (
  user: UserIdentificationData | null,
  intro: CarProductIntroFormValues,
  details: CarProductDetailsFormValues,
  price?: CarPriceFormValues,
): CarPriceRequestInfo => ({
  dateOfBirth: user?.newCustomerResponse.dateOfBirth || "",
  tfaCode: intro.tfaCode,

  // intro
  brand: intro.brand,
  model: intro.model,
  year: Number(intro.year),
  carKw: intro.kw,
  carVolume: intro.volume,
  configurationId: intro.configurationId,

  // details
  bonusLevelCode: details.bonus,

  mortgagee:
    price?.carOwner !== CarOwner.LEASING
      ? formBooleanToBoolean(details.mortgagee)
      : false,
  injuries: Number(details.injuries),
  injuryYear:
    details.injuries !== DamageRecentYears.NONE
      ? Number(details.injuryYear)
      : 0,

  // price
  yearlyKmNeed: determineYearlyKmNeed(user, price),
  usedByYoungerDriver: usedByYoungerDriver(
    user,
    price?.usedByYoungerDriver,
    price?.carOwnerAge,
  ),
  rentalType:
    price?.rentalType === RENTAL_TYPE_VARIABLE.NONE ? null : price?.rentalType,
  issueDate: getCarPriceIssueDate(intro.warrantyType),
  insuranceHolderIsCarOwner: price?.carOwner === CarOwner.MYSELF,
  carOwner: price?.carOwner,
  carOwnerAge:
    price?.carOwner === CarOwner.GUARDIAN ||
    price?.carOwner === CarOwner.PARTNER
      ? Number(price.carOwnerAge)
      : Number(user?.newCustomerResponse.age),
});

const determineYearlyKmNeed = (
  user: UserIdentificationData | null,
  price?: CarPriceFormValues,
): number => {
  if (isSTBEmployee(user)) {
    return 1;
  }
  return isDefined(price) && isDefined(price.yearlyKmNeed)
    ? Number(price.yearlyKmNeed)
    : 2;
};
